import { IApplication } from '../../interfaces/applicationTrackingSystem/iApplication'
import { IAnswer } from '../../interfaces/applicationTrackingSystem/iAnswer'
import { IMessage } from '../../interfaces/applicationTrackingSystem/iMessage'
import { INonprofit } from '../../interfaces/applicationTrackingSystem/iNonprofit'
import { IMember } from '../../interfaces/iMember'
import { iApplicationProgress } from '../../interfaces/applicationTrackingSystem/iApplicationProgress'
import { IMemberOrganisationCard } from '../../interfaces/iMemberOrganisationCard'
import { MemberOrganisationCard } from '../memberOrganisationCard'

export class Application implements IApplication {

	applicationKey: string;
    filter: string;
	role: string;
	step: number;
    nodeProgress : string;
	status: string;
	answers: IAnswer[];
	templateOfMessage: IMessage; 
	messages: IMessage[];
	nonprofit: INonprofit;
    company: INonprofit;
	member: IMember;
    opportunityKey: string;
    isAdmin: boolean;
    isAppliedByCurrentUser: boolean;
    isManual: number;
    progress?: iApplicationProgress[];
    forAdmin?: number;
    oppAdmins?: IMemberOrganisationCard[];
    feedbackGiven?: boolean;

    constructor(application: IApplication = {} as IApplication) {
        this.applicationKey = application.applicationKey;
        this.isAdmin = !!application.isAdmin;
        this.isAppliedByCurrentUser = !!application.isAppliedByCurrentUser;
        this.role = application.role;
        this.step = application.step;
        this.status = application.status;
        this.answers = application.answers;
        this.templateOfMessage = application.templateOfMessage;
        this.messages = application.messages;
        this.nonprofit = application.nonprofit;
        this.company = application.company;
        this.member = application.member;
        this.opportunityKey = application.opportunityKey;
        this.isManual = application.isManual;
        this.nodeProgress = application.nodeProgress;
        this.progress = application.progress;
        this.forAdmin = application.forAdmin;
        this.feedbackGiven = !!application.feedbackGiven;
        this.filter = application.filter;
        if (application.oppAdmins) {
            this.oppAdmins = application.oppAdmins;
        }
	}
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/applicationTrackingSystem/application.ts